import {MenuItem, TextField, TextFieldProps} from "@mui/material";
import React from "react";

interface SelectNullableBoolProps extends Omit<TextFieldProps, 'type' | 'select' | 'value' | 'onChange'> {
    value?: 'true' | 'false'
    onChange?: (value?: 'true' | 'false') => void,
    labels?: {
        true?: string
        false?: string
        undefined?: string
    }
}

export function SelectNullableBool(props: SelectNullableBoolProps) {
    const {value, onChange, labels, ...rest} = props;

    return (
        <TextField select value={value ?? 'undefined'}
                   size={'small'}
                   onChange={(e) => {
                       const {target: {value}} = e;
                       if (onChange != null) {
                           onChange(value as 'true' | 'false')
                       }
                   }} {...rest}>
            <MenuItem value={'undefined'}>{labels?.['undefined'] ?? 'Qualquer'}</MenuItem>
            <MenuItem value={'true'}>{labels?.['true'] ?? 'Sim'}</MenuItem>
            <MenuItem value={'false'}>{labels?.['false'] ?? 'Não'}</MenuItem>
        </TextField>
    )
}